import { create } from 'zustand'

interface CommonStorageType {
  source: 'app' | 'web' | null
  setSource: (source: 'app' | 'web') => void
}

const initialState = {
  initialRatingCsat: 0,
  csatToken: null,
  csatData: null,
  csatAnswer: null,

  initialRatingNps: 0,
  npsToken: null,
  npsData: null,
  npsAnswer: null,

  source: null,
  errorType: null
}

const useStorageCommon = create<CommonStorageType>((set) => ({
  ...initialState,
  setSource: (source?: 'app' | 'web' | null) => set({ source: source || 'web' })
}))

export default useStorageCommon

